import type { LocalDatabase, QueryFunction } from './types';
import type { CompilableQuery } from '@powersync/react-native';
import type { Database } from '~/powersync/generated/schema';

/**
 * Helper function to create queries that handle optional/null IDs
 * Returns empty result when ID is null/undefined
 */
export const withOptionalId = <T>(
  tableName: keyof Database,
  queryBuilder: (db: LocalDatabase, id: string) => CompilableQuery<T>,
): ((id: string | null | undefined) => QueryFunction<T>) => {
  return (id: string | null | undefined) => (db: LocalDatabase) => {
    if (!id) {
      // Return empty result when no ID provided
      return db
        .selectFrom(tableName)
        .selectAll()
        .where('id', '=', 'non-existent');
    }

    return queryBuilder(db, id);
  };
};
